import React, { FC } from 'react'
import classNames from 'classnames'
import { BasicCarousel } from '@/molecules/BasicCarousel'
import { useGuildMember } from '@/services/GuildUserService'
import { Media } from '@/utils/EpisodeUtil'
import { FranchiseMediaCard } from './FranchiseMediaCard'

interface FranchiseMediaHorizontalScrollerProps {
  medias: Media[]
  padding?: boolean
  hasWatchableReasons?: boolean
  containerPosition: number
  contentTypeName?: 'ContentEpisode' | 'ContentLivestream' | 'ContentMovie' | 'ContentSpecial'
}

export const FranchiseMediaHorizontalScroller: FC<FranchiseMediaHorizontalScrollerProps> = ({
  medias,
  padding = false,
  hasWatchableReasons = false,
  containerPosition,
  contentTypeName = 'ContentEpisode',
}) => {
  const { guildPermissions } = useGuildMember()
  const userHasEarlyAccess = Boolean(guildPermissions.hasEarlyAccess)
  const hasMediaCards = Boolean(medias?.length)

  return (
    <BasicCarousel containerClassName={classNames({ 'px-4 sm:px-8 md:px-12 xl:px-16': padding })}>
      {hasMediaCards &&
        medias?.map?.((media, i) => {
          return (
            <FranchiseMediaCard
              className="w-2/3 min-w-[256px] max-w-[300px] shrink-0 snap-center snap-always sm:w-2/5 lg:w-3/5"
              {...media}
              key={media.guid}
              imgPriority={i <= 4}
              includeHoverScale={false}
              userHasEarlyAccess={userHasEarlyAccess}
              hasWatchableReasons={hasWatchableReasons}
              itemIndex={i}
              containerPosition={containerPosition}
              contentTypeName={contentTypeName}
            />
          )
        })}
    </BasicCarousel>
  )
}
